module.exports = __webpack_public_path__ + "static/media/playspace_section3.1f691f63.png";